import { useEffect, useMemo, useState } from 'react';
import { useIsMounted } from '../use-is-mounted/useIsMounted';

export const useToggle = (initialState = false) => {
  const isMounted = useIsMounted();
  const [state, setState] = useState(initialState);

  const handlers = useMemo(
    () => ({
      on() {
        if (isMounted()) setState(true);
      },
      off() {
        if (isMounted()) setState(false);
      },
      toggle() {
        if (isMounted()) setState((prevState) => !prevState);
      },
      reset() {
        if (isMounted()) setState(initialState);
      },
    }),
    [initialState, isMounted],
  );

  useEffect(() => {
    // eslint-disable-next-line react-x/set-state-in-effect -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
    setState(initialState);
  }, [initialState]);

  return [state, handlers] as const;
};
